import { useAtom } from "jotai";

import { tlrAtom } from "@shared/state";

export const useTimeLookbackRange = () => {
  return useAtom(tlrAtom);
};
